// extracted by mini-css-extract-plugin
export const link = "our-dream-module--link--3ZQvm";
export const ourDreamImg = "our-dream-module--our-dream-img--2BbY0";
export const ourDreamHeader = "our-dream-module--our-dream-header--2uQ6U";
export const imgContainer = "our-dream-module--imgContainer--PDp_c";